import Repository from './Repository'

export default {
  getTeamCategories(queries: any) {
    return Repository.get('category/team', { params: queries })
  },
  getTopicCategories(queries: any) {
    return Repository.get('/category/topic', { params: queries })
  }
}